<!--
  アクティビティアマウント表示コード
-->
<template>
  <v-main class="pa-0">
    <div class="pa-5 pagetitle">アクティビティアマウント</div>
    <v-container>
      <v-row>
        <!--左上・ユーザー画像-->
        <v-col cols="6">
          <v-card
            class="mx-auto text-center amcard d-flex flex-column"
            height="200px"
            color="#CCE8FF"
          >
            <v-img
              v-if="profImageO"
              v-bind:src="profImageO"
              max-height="60%"
              max-width="60%"
              class="mx-auto mt-2 pa-6 rounded-circle"
            >
            </v-img>
            <v-icon v-else size="150"> mdi-account </v-icon>
            <h2 class="mt-auto mb-4" v-if="name" v-text="name"></h2>
          </v-card>
        </v-col>
        <!--右上・アイデア投稿件数-->
        <v-col cols="6">
          <v-card class="mx-auto text-center amcard" height="200px">
            <v-card-text class="amtitle"
              >{{ $t("アイデア") }}投稿件数</v-card-text
            >
            <v-card-text class="amcount">{{ count_ideapost }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <!--左下・チャット投稿件数-->
        <v-col cols="6">
          <v-card class="mx-auto text-center amcard" height="200px">
            <v-card-text class="amtitle">{{ $t("チャット") }}投稿件数</v-card-text>
            <v-card-text class="amcount">{{ count_comments }}</v-card-text>
          </v-card>
        </v-col>
        <!--右下・修正提案投稿件数-->
        <v-col cols="6">
          <v-card class="mx-auto text-center amcard" height="200px">
            <v-card-text class="amtitle">修正提案投稿件数</v-card-text>
            <v-card-text class="amcount">{{ count_amendments }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
  <script>
import firebase from "firebase";
export default {
  data() {
    return {
      db: null,
      name: "",
      count_ideapost: 0,
      count_comments: 0,
      count_proposals: 0,
      count_amendments: 0,
      count_like: 0,
      profImageO: "",
      profImageS: "",
    };
  },
  props: ["profuid"],
  created() {
    this.db = firebase.firestore();
    this.updateCounter(this.profuid);
    this.getProfimg(this.profuid);
  },
  watch: {
    profuid: function (profuid) {
      this.updateCounter(profuid);
      this.getProfimg(profuid);
    },
  },
  methods: {
    updateCounter(uid) {
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .collection("counter")
        .doc("counter")
        .get()
        .then((doc) => {
          //カウンターの取得
          if (doc.data() != undefined) {
            if (doc.data().count_ideapost != undefined) {
              this.count_ideapost = doc.data().count_ideapost;
            }
            if (doc.data().comments != undefined) {
              this.count_comments = doc.data().comments;
            }
            if (doc.data().proposals != undefined) {
              this.count_proposals = doc.data().proposals;
            }
            if (doc.data().amendments != undefined) {
              this.count_amendments = doc.data().amendments;
            }
            if (doc.data().like != undefined) {
              this.count_like = doc.data().like;
            }
          }
        });
    },
    getProfimg(uid) {
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .get()
        .then((doc) => {
          //プロフィールの取得
          this.name = doc.data().name;
          this.profImageO = doc.data().profImageO;
          this.profImageS = doc.data().profImageS;
        });
    },
  },
};
</script>
  <style scoped>
.pagetitle {
  font-size: large;
  color: #707070;
}
.amcard {
  height: 400px;
}
.amtitle {
  position: relative;
  top: 10%;
  color: #294a66 !important;
}
.amcount {
  position: relative;
  top: 20%;
  color: black !important;
  font-size: 70px;
}
* {
  font-family: mplus-2c-medium;
}
</style>